<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';

const ICON_SIZE = 14;

defineProps<{
  label: string;
  showIcon?: boolean;
  /** Optional collection gradient, rendered as a small dot before the label. */
  gradient?: string;
}>();
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-neutral-200 bg-white px-2.5 py-0.5 text-xs font-medium text-neutral-500"
  >
    <HugeIcon v-if="showIcon" icon="library" :size="ICON_SIZE" />
    <span
      v-if="gradient"
      class="h-2 w-2 rounded-full"
      :style="{ background: gradient }"
    />
    {{ label }}
  </span>
</template>
